import React from "react";
import { Briefcase } from "lucide-react";
import { motion } from "framer-motion";

const experiences = [
  {
    title: "Full Stack Developer",
    company: "Delta V Logic and Solutions",
    period: "2024",
    description: [
      "Developed and maintained client web applications",
      "Integrated third-party APIs and services",
      "Optimized application performance and user experience",
    ],
  },
  {
    title: "Full Stack Developer",
    company: "Digital Terai",
    period: "2023 - 2024",
    description: [
      "Developed and maintained client web applications",
      "Integrated third-party APIs and services",
      "Debugged and resolved issues",
    ],
  },
  {
    title: "Full Stack Developer Intern",
    company: "Digital Terai",
    period: "2023",
    description: [
      "Built responsive web interfaces using React",
      "Collaborated with designers to implement UI/UX improvements",
      "Developed reusable component libraries",
    ],
  },
];

const checkerboardVariants = {
  hidden: { opacity: 0, scale: 0.8, x: 50 }, // Start offscreen to the right
  visible: {
    opacity: 1,
    scale: 1,
    rotate: 0,
    x: 0, // Moves to its final position
    transition: { duration: 1, ease: "easeOut" },
  },
};

function Experience() {
  return (
    <section id="experience" className="py-20 bg-gray-100 dark:bg-gray-900">
      <div className="container mx-auto px-4">
        <motion.div
          variants={checkerboardVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.5 }}
        >
          <h2 className="text-4xl font-bold text-center mb-16 bg-gradient-to-r from-blue-600 to-teal-400 bg-clip-text text-transparent">
            Work Experience
          </h2>
        </motion.div>

        <div className="max-w-3xl mx-auto">
          {experiences.map((experience, index) => (
            <div key={index} className="relative pl-8 pb-12 last:pb-0">
              {index !== experiences.length - 1 && (
                <div className="absolute left-[11px] top-0 h-full w-px bg-gray-200 dark:bg-gray-700" />
              )}
              <motion.div
                key={index}
                // className="bg-gray-200 dark:bg-gray-900 rounded-lg p-6 shadow-lg flex flex-col items-center"
                variants={checkerboardVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ amount: 0.5 }}
              >
                <div className="absolute left-0 top-0 p-1 bg-white dark:bg-gray-900">
                  <div className="p-2 bg-blue-100 dark:bg-blue-900 rounded-full">
                    <Briefcase className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                  </div>
                </div>

                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-6">
                  <h3 className="text-xl font-semibold mb-1">
                    {experience.title}
                  </h3>
                  <div className="flex items-center gap-2 text-gray-600 dark:text-gray-300 mb-4">
                    <span>{experience.company}</span>
                    <span>•</span>
                    <span>{experience.period}</span>
                  </div>

                  <ul className="space-y-2">
                    {experience.description.map((item, itemIndex) => (
                      <li
                        key={itemIndex}
                        className="flex items-start gap-2 text-gray-600 dark:text-gray-300"
                      >
                        <span className="mt-2 w-1.5 h-1.5 bg-blue-600 dark:bg-blue-400 rounded-full flex-shrink-0" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
